"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const plus_1 = require("../icons/plus");
exports.default = plus_1.Plus;
